export default __webpack_public_path__ + "static/media/wavingHand.95478af6.svg";